interface CTASectionProps {
    readonly onCreateClick: () => void;
}

export function CTASection({ onCreateClick }: CTASectionProps) {
    return (
        <section className="cta-section">
            <div className="container animate-on-scroll">
                <h2 className="cta-section__title">
                    Ready to Make a Difference?
                </h2>
                <p className="cta-section__desc">
                    Start your own campaign or fund one that matters. Every satoshi counts.
                    Zero fees. 100% on-chain.
                </p>
                <button className="btn btn--primary btn--lg" onClick={onCreateClick}>
                    + Create Your Campaign
                </button>
            </div>
        </section>
    );
}
